import light from "./light.systemTokens.sdb.theme.js";
import lightContrast from "./lightContrast.systemTokens.sdb.theme.js";
import dark from "./dark.systemTokens.sdb.theme.js";
import darkContrast from "./darkContrast.systemTokens.sdb.theme.js";
export const sdbThemeSystemTokens = { light, lightContrast, dark, darkContrast };
export default sdbThemeSystemTokens;
